export const FEATURE_TOGGLES = {
  STARS_NEW_EXPORT: 'stars-new-export'
};
